import type { FC } from 'react';

import type { FieldName } from '@conform-to/react';
import { getInputProps, useField } from '@conform-to/react';

import { cn } from '~/styling';

const TEST_ID_MAP: Record<string, string> = {
  email: 'email-input',
  firstName: 'first-name-input',
  lastName: 'last-name-input',
  phone: 'phone-input',
  streetAddress1: 'street-address-input',
  streetAddress2: 'street-address2-input',
  postalCode: 'postal-code-input',
  city: 'city-input',
  cityArea: 'city-area-input',
};

interface ITextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: FieldName<string | number | null | undefined>;
  label: string;
  type: 'text' | 'email' | 'password' | 'number';
}

const TextInput: FC<ITextInputProps> = ({ name, label, type, ...options }) => {
  const [field] = useField(name);

  return (
    <div className="">
      <div>
        <input
          className={cn(
            'w-full rounded-lg border px-4 py-6 placeholder:text-primary-2-40',
            field.errors ? 'border-system-error focus:border-system-error' : 'border-primary-3-20'
          )}
          placeholder={label}
          data-testid={TEST_ID_MAP[field.name]}
          {...getInputProps(field, { type })}
          {...options}
        />
      </div>
      <div className="text-system-error mt-2">
        {field.errors?.map((error) => (
          <p key={error} data-testid={TEST_ID_MAP[field.name]?.replace('-input', '-error')}>
            {error}
          </p>
        ))}
      </div>
    </div>
  );
};

export default TextInput;
